import React from 'react'
import { NavLink } from 'react-router'
import { Collapse } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HelpTwoToneIcon from '@mui/icons-material/HelpTwoTone'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import { Chat } from '@mui/icons-material'
import ContactDialog from '@/housefolios-components/Dialogs/ContactSupport'
import { sidebarNestedLinkIconSx } from '@/layout-blueprints/chromeComponentSx'

const SupportSection = ({
  supportDropdownOpen,
  toggleSupportDropdown,
  setOpenFeedbackTour,
  urlAffiliate,
  openDialog,
  handleClose,
  handleClickOpen,
  session,
}) => (
  <li>
    <a
      id="leftNavSettings"
      href="#/"
      onClick={toggleSupportDropdown}
      data-nav-active={supportDropdownOpen || undefined}
    >
      <span data-hf="sidebar-icon">
        <HelpTwoToneIcon />
      </span>
      <span data-hf="sidebar-item-label">Support</span>
      <span data-hf="sidebar-icon-indicator">
        <ChevronRightTwoToneIcon />
      </span>
    </a>
    <Collapse in={supportDropdownOpen}>
      <ul>
        <li>
          <NavLink
            id="leftNavSupportTutorial"
            onClick={() => {}}
            to="/training"
          >
            <FontAwesomeIcon
              sx={sidebarNestedLinkIconSx}
              icon={['fas', 'user-graduate']}
              size="1x"
              fixedWidth
            />
            Training
          </NavLink>
        </li>
        {!urlAffiliate && (
          <li>
            <NavLink
              id="leftNavSupport"
              data-hf="nav-link-simple"
              to="/support-chat"
            >
              <Chat sx={sidebarNestedLinkIconSx} />
              Live Chat
            </NavLink>
          </li>
        )}
        {!urlAffiliate && (
          <li>
            <a
              id="leftNavFeedback"
              data-tour="feedback-step-1"
              href="#/"
              onClick={() => setOpenFeedbackTour(true)}
            >
              <FontAwesomeIcon
                sx={sidebarNestedLinkIconSx}
                icon={['fal', 'comment-dots']}
                size="1x"
                fixedWidth
              />
              <span data-hf="sidebar-item-label">Feedback</span>
            </a>
          </li>
        )}
        {urlAffiliate && (
          <>
            <li>
              <a
                id="leftNavContactSupport"
                href="#/"
                onClick={handleClickOpen}
              >
                <FontAwesomeIcon
                  sx={sidebarNestedLinkIconSx}
                  icon={['fas', 'phone']}
                  size="1x"
                  fixedWidth
                />
                <span data-hf="sidebar-item-label">
                  Contact Support
                </span>
              </a>
            </li>
          </>
        )}
        <ContactDialog
          open={openDialog}
          handleClose={handleClose}
          activeOrg={session?.me?.activeOrg?.member}
          session={session}
        />
      </ul>
    </Collapse>
  </li>
)

export default SupportSection
